import React, { useMemo } from "react";
import { Platform, StyleSheet, View } from "react-native";
import { ColorTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, MessageAlignType, ProgressIndicatorTypeTokens, StepperTypeTokens, } from "@voltmoney/schema";
import { Typography } from "../../typography/Typography";
import { Header } from "../../header/Header";
import { ProgressIndicator } from "../../progressIndicator/ProgressIndicator";
import { Message } from "../../message/Message";
const AgreementPolling = ({ height, stepperData }) => {
    const stepperProps = {
        data: stepperData,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null
    };
    const _headerChild = useMemo(() => {
        return (React.createElement(Header, { type: HeaderTypeTokens.verification, stepperProps: stepperProps, isBackButton: true, title: "Setup Agreement", onPress: () => {
            } }));
    }, []);
    return (React.createElement(View, { style: [styles.container, { height: height - 16 }] },
        React.createElement(View, { style: styles.headerStyle }, _headerChild),
        React.createElement(View, { style: { alignSelf: 'center', alignContent: 'center' } },
            React.createElement(ProgressIndicator, { activeIndex: 1, type: ProgressIndicatorTypeTokens.LINEAR }),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(Typography, { label: 'Generating Agreement link', color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.SM, lineHeight: 24, fontFamily: FontFamilyTokens.Inter, fontWeight: '600' }),
                React.createElement(View, { style: { marginTop: 2 } },
                    React.createElement(Typography, { label: 'We’re verifying your details. It may take up to 60 seconds', color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, lineHeight: 18, fontFamily: FontFamilyTokens.Inter, fontWeight: '400' })))),
        React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                justifyContent: 'center',
                width: '100%',
                paddingBottom: 16,
                paddingHorizontal: 16,
                backgroundColor: '#FAFBFE'
            } },
            React.createElement(Message, { labelColor: ColorTokens.Green_90, bgColor: ColorTokens.Primary_02, alignText: MessageAlignType.CENTER, label: 'Do not leave at this step' }))));
};
const styles = StyleSheet.create({
    container: {
        marginHorizontal: -16
    },
    bodyContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        flexDirection: 'column',
        flex: 1,
        padding: 8
    },
    overlay: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%'
    },
    headerStyle: {
        ...Platform.OS === "ios" && {
            marginTop: 24
        }
    },
    successCard: {
        alignItems: "center", flex: 1, height: 260, padding: 16
    },
    successLottie: { width: 70, height: 'auto' },
    halfCardTitle: { marginTop: 16 },
    halfCardDescription: { marginTop: 4 },
    successCTA: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        paddingHorizontal: 16,
        marginBottom: 16,
        marginTop: 24,
    },
});
// @ts-ignore
export default (AgreementPolling);
